import React from 'react';
import { bool, object, string } from 'prop-types';
import ListingImageGallery from './ListingImageGallery/ListingImageGallery';

import css from './ListingPage.module.css';

const SectionGallery = props => {
  const { listing, variantPrefix, prioritizeLcp = true } = props;
  const images = listing.images;
  const imageVariants = ['scaled-small', 'scaled-medium', 'scaled-large', 'scaled-xlarge'];
  // Thumbnails render at <=88px: lead with the small `-thumb` (200px) rendition and keep the
  // 400px `listing-card` as a high-DPR fallback so retina screens still look crisp.
  const thumbnailVariants = [`${variantPrefix}-thumb`, variantPrefix];
  return (
    <div className={css.productGallery} data-testid="carousel">
      <ListingImageGallery
        images={images}
        imageVariants={imageVariants}
        thumbnailVariants={thumbnailVariants}
        prioritizeLcp={prioritizeLcp}
      />
    </div>
  );
};

SectionGallery.defaultProps = {
  prioritizeLcp: true,
};

SectionGallery.propTypes = {
  listing: object.isRequired,
  variantPrefix: string.isRequired,
  prioritizeLcp: bool,
};

export default SectionGallery;
